import { render } from "./FooterNavigation.vue?vue&type=template&id=5d12d1fd"
import script from "./FooterNavigation.vue?vue&type=script&lang=js"
export * from "./FooterNavigation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__